import React, { Fragment, useState, useEffect, useContext } from 'react';
import TableBuilder, { ApiRequestBuilder, ButtonBuilder, ModalButtonBuilder, RegisteredInputsBuilder, ToastBuilder } from '../../GlobalComponents/Builders';
import { Container, Row, Card, CardBody, Form } from 'reactstrap'
import { Link } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { ContentLoader } from '../../Layout/Loader';

const ServiceList = () => {

    const [serviceData, setServiceData] = useState([]);
    const [isProcessing, setIsProcessing] = useState(true);
    const [manage, setManage] = useState([]);

    const { register, handleSubmit, formState: { errors } } = useForm();

    const handleServiceCreate = (newServiceData) => {

        ApiRequestBuilder('servicesPost', null, newServiceData).then(function(results){
            ToastBuilder('success', 'Service Creation Successful')

            if (results.data.id)
            {
                window.location.href = process.env.PUBLIC_URL + '/services/' + String(results.data.id)
            }
            else
            {
                ToastBuilder('error', 'Unable to Create Service')
            }

        }).catch((err) => {
            console.log(err);
            ToastBuilder('error', 'Unable to Create Service')
        })
    }

    const getServices = () => {
        ApiRequestBuilder('servicesGet', null, null)
            .then(function(results) {
                setServiceData(results.data && results.data.length > 0 ? results.data : [])
            }
        )

        ApiRequestBuilder('servicesGet', null, null, { setIsProcessing }, {table : 'v_service_resource'})
            .then(function(results) {
                if (results.data && results.data.length > 0){
                    setManage(results.data.map(service => service.id))
                }
            }
        )
    }

    useEffect(() => {

        document.title = 'View Services'

        getServices()
    }, []);

    return (
            <Fragment>
                <ContentLoader isLoading={isProcessing}/>
                <Row>
                    <Container>
                        <Card>
                        <CardBody>
                            <TableBuilder
                                subHeader={true}
                                columnsToSearch={['name']}
                                paginationPerPage={15}
                                data={serviceData}
                                processing={isProcessing}
                                title='Services'
                                columns = {[
                                    {
                                        name: 'ID',
                                        selector: (row) => row.id,
                                        sortable: true,
                                        center: true,
                                        maxWidth: '15%',
                                    },
                                    {
                                        name: 'Name',
                                        selector: (row) => row.name,
                                        sortable: true,
                                        center: true,
                                    },
                                    // {
                                    //     name: 'Settings',
                                    //     selector: (row) => <Link to={`${process.env.PUBLIC_URL}/services/${row.id}`}>View / Edit</Link>,
                                    //     sortable: true,
                                    //     center: true,
                                    //     maxWidth: '25%',
                                    // },
                                    {
                                        name: 'Resources',
                                        selector: (row) => manage.includes(row.id) ? <Link to={`${process.env.PUBLIC_URL}/services/${row.id}/resources`}>View / Edit</Link> : ' - ',
                                        sortable: true,
                                        center: true,
                                        maxWidth: '25%',
                                    },
                                ]}
                            />
                        </CardBody>
                        </Card>
                    </Container>
                </Row>
            </Fragment>
    );
};

export default ServiceList;